import _ from 'underscore';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { TagsHelper } from '../../../ts/helpers/TagsInputHelper';
import { ITagsParams } from '../../../ts/ServerApi/types/actionParams';

export class RemoveTagsFromPublishedConnectionTablesRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    // The server returns quoted tags unquoted.  This re-adds the double quotes if needed
    const tagsList = _.map(tags, (tag: string) => TagsHelper.quote(tag));

    super('removeTagsFromPublishedConnectionTables', {
      ids: ids,
      tags: tagsList
    });
  }
}
